import { css, } from 'styled-components';
const breakpoints = {
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
};
const media = Object.keys(breakpoints).reduce((acc, label) => {
    const testLabel = label;
    if (typeof label !== 'string')
        return acc;
    acc[testLabel] = (literals, ...placeholders) => css `
      @media (min-width: ${breakpoints[testLabel] / 16}em) {
        ${css(literals, ...placeholders)}
      }
    `;
    return acc;
}, {});
export default media;
//# sourceMappingURL=media.js.map